import { trackAnalyticsEvent } from '@cof/refi-web-sdk';

function isStaticCloud() {
  return window.location.host === 'auto-refi-dev.clouddqt.capitalone.com' || window.location.host === 'auto-refi-sb.clouddqt.capitalone.com' || window.location.host === 'auto-refi-perf.clouddqt.capitalone.com';
}
const ENV_PATH = isStaticCloud() ? '/_origin/dxgw/_call' : '';

export const REFI_ESIGN_CONST = {
  get API_PREFIX() {
    if (REFI_ESIGN_CONST.isLocalEnv) {
      return '';
    }
    if (REFI_ESIGN_CONST.isProdEnv) {
      return 'https://api.capitalone.com';
    }
    return 'https://api-it.capitalone.com';
  },
  get ESIGN_BFF_URL() {
    return `${ENV_PATH}/protected/942605/applications`;
  },
  get HOST_BFF_URL() {
    return `${ENV_PATH}/protected/831647/host-app/bff`;
  },
  GET_FEATURE_TOGGLE_URL: featureKey => `${ENV_PATH}/protected/942605/features/${featureKey}`,
  ASSETS_URL: `${new URL(import.meta.url)?.origin}/assets`,
  HTTP_HEADERS: {
    Accept: 'application/json;v=1',
    'Content-Type': 'application/json;v=1',
    Cookie: '',
  },
  C1_REFI_APPIDS: 'C1-REFI-APPIDS',
  REFI_CUSTOMER_EXPERIENCE_KEY: 'customer-experience',
  REFI_SESSION_KEY: 'auto-refi-session',
  REFI_PI_KEY: 'auto-refi-pi',
  MARKETING_ATTRIBUTE_COOKIE: 'afw3', // set in persist-marketing-attributes
  CONTRACT_FILES_READY_EVENT: new CustomEvent('contract-files-ready', { bubbles: true, composed: true }),
  VALID_ID_ANSWERS_EVENT: new CustomEvent('verified-id'),
  NEXT_MFE_EVENT: new CustomEvent('host-app-event', {
    bubbles: true,
    composed: true,
    detail: {
      actionName: 'next-mfe',
      data: {
        currentMfe: 'esign',
      },
    },
  }),
  ROUTE_CHANGE: 'mfe-internal-route-change',
  ROUTE_CHANGE_EVENT: new CustomEvent('mfe-internal-route-change'),
  TRACK_EVENT: trackAnalyticsEvent,
  API_ERR_MSG: 'Our system experienced an error. Please try again later. For help right now, you can call us at 1-888-263-4582.',
  CUSTOMER_EXPERIENCES: {
    ICONIC_CONTRACT: 'ICONIC_CONTRACT',
    COMBINED_HP_CONTRACT_V1: 'combined-hp-cont-v1',
    COMBINED_HP_CONTRACT_V2: 'combined-hp-cont-v2',
  },
  FEATURE_TOGGLES: {
    ICONIC_ETITLE_FEATURE_TOGGLE: 'iconic-etitle',
    CXTFLOW_FEATURE_TOGGLE: 'cxt-flow-expanded-contract',
    COMBINED_HP_CONTRACT: 'combined-hp-cont',
    DELAYED_HARDPULL: 'delayed-hard-pull-allocation-call',
  },
  PUBLIC_KEY_PRODUCT_ID: 'refiSpringbootKeys',
  HIGHLINE: {
    URL_PREFIX: () => `${ENV_PATH}`,
  },
  get isLocalEnv() {
    return window.location.hostname === 'localhost';
  },
  get isSBEnv() {
    return ['auto-refi-sb.clouddqt.capitalone.com', 'coaf-esign-mfe-sb.capitalone.com'].includes(window.location.hostname);
  },
  get isDevEnv() {
    return ['auto-refi-dev.clouddqt.capitalone.com', 'coaf-esign-mfe-dev.capitalone.com'].includes(window.location.hostname);
  },
  get isQAEnv() {
    return ['autorefi-ext-preprod.capitalone.com', 'coaf-esign-mfe-qa.capitalone.com'].includes(window.location.hostname);
  },
  get isProdEnv() {
    return ['autorefi.capitalone.com', 'coaf-refi-web-ui.capitalone.com', 'coaf-esign-mfe.capitalone.com'].includes(window.location.hostname);
  },
  EXP_FEEDBACK_EVENT: (experimentName, feedback) =>
    new CustomEvent('host-app-event', {
      bubbles: true,
      composed: true,
      detail: {
        actionName: 'experiment-feedback',
        data: {
          experimentName,
          feedback,
        },
      },
    }),
  EXP_INIT_EVENT: experimentName => this.EXP_FEEDBACK_EVENT(experimentName, { feedbackEvent: 'Initialized' }),
  EXP_SUCCESS_EVENT: (experimentName, rewardValue = 1) =>
    this.EXP_FEEDBACK_EVENT(experimentName, {
      feedbackEvent: 'Success',
      rewardValue,
    }),
  EXPERIMENTS: {
    POATA_REMOVE_SKIP: 'poata-remove-skip',
    POATA_REMOVE_SKIP_TEST_VARIANT: 'poata-unskippable',
  },
};
